import type { PropsWithChildren } from "react";

import { IconButton, icons } from "@/ui";

type MoreTabPanelProps = PropsWithChildren<{
  title: string;
  onBack: () => void;
}>;

export const MoreTabPanel = ({ children, onBack, title }: MoreTabPanelProps) => {
  return (
    <section className="absolute inset-0 flex size-full flex-col bg-canvas sm:relative sm:overflow-y-auto sm:pl-1.5">
      <div className="mb-3 flex items-center gap-2 sm:hidden">
        <IconButton className="-ml-2" label={`Back to settings from ${title}`} onClick={onBack}>
          <icons.ChevronLeftIcon aria-hidden="true" className="size-6 stroke-content" />
        </IconButton>

        <h2 className="text-xl font-bold text-content">{title}</h2>
      </div>

      {children}
    </section>
  );
};
